var map = {
	"./Zodiac-Wallpaper-25.jpg": 742,
	"./clouds-moonlight-wallpaper-preview.jpg": 356,
	"./cm8kfv5rvls8mkuvv8hb.jpg": 3808,
	"./night-sky-wallpaper-thumb.jpg": 2022
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3000;